import { render, staticRenderFns } from "./editbetting.vue?vue&type=template&id=3b3fad90&"
import script from "./editbetting.vue?vue&type=script&lang=js&"
export * from "./editbetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports